import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/avg/calendar', { params }),
  create: (params) => axios.post('/api/v1/avg/calendar', params),
};
